// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"1bd20408","873":"bf268187"}[chunkId] + ".chunk.css";
};